"use client";

import { createAbsoluteUrl } from "@/service/url";
import { createPath } from "@/service/routing/routing";
import { TutorialStructuredData } from "@/components/common/structured-data/tutorial-structured-data";

export const StructuredData = ({ tutorial }: { tutorial: TutorialVM }) => {
  return (
    <TutorialStructuredData
      tutorial={tutorial}
      url={createAbsoluteUrl(
        createPath("tutorial.show", {
          category: tutorial.category.slug,
          tutorial: tutorial.slug,
        }),
      )}
    />
  );
};
